var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "completeness-page" },
    [
      _c("completeness-check-details-modal", {
        ref: _vm.REF_CONSTANTS.COMPLETENESS_CHECK_DETAILS_MODAL,
      }),
      _c(
        "div",
        { staticClass: "completeness-page__top-section" },
        [
          _c("pui-filter", {
            attrs: {
              config: _vm.filterConfiguration,
              "vuex-namespace": "qmdi-completeness-check",
            },
            on: { "changed:applied-values": _vm.filtersChanged },
          }),
          _c(
            "div",
            {
              staticClass:
                "completeness-page__top-section__date-selector-section",
            },
            [
              _c("pui-date-time-selector", {
                attrs: {
                  start: _vm.range.start,
                  end: _vm.range.end,
                  "date-picker-options": {
                    selectableRange: _vm.SELECTABLE_RANGE,
                  },
                },
                on: {
                  "update:start": function ($event) {
                    return _vm.$set(_vm.range, "start", $event)
                  },
                  "update:end": function ($event) {
                    return _vm.$set(_vm.range, "end", $event)
                  },
                  apply: _vm.rangeChanged,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "pui-tabs",
        {
          staticClass: "completeness-page__tabs",
          on: { changed: _vm.tabChanged },
        },
        [
          _c("pui-tab", { attrs: { title: _vm.$t("countedValues") } }),
          _c("pui-tab", { attrs: { title: _vm.$t("measuredValues") } }),
          _c("pui-tab", { attrs: { title: _vm.$t("dayAheadValues") } }),
          _c("pui-tab", { attrs: { title: _vm.$t("auxiliaryValues") } }),
        ],
        1
      ),
      _vm.isRangeValid
        ? _c(
            "pui-loader",
            { attrs: { promise: _vm.completenessPromise } },
            [
              _vm.shouldDisplayNoDataCard
                ? _c(
                    "div",
                    [
                      _c("pui-loader-error", {
                        staticClass: "completeness-page__card",
                        attrs: {
                          title: _vm.$t("completenessCheckPage.noData"),
                          message: _vm.$t(
                            "completenessCheckPage.noDataForRange"
                          ),
                          icon: "error-empty-data",
                        },
                      }),
                    ],
                    1
                  )
                : _vm.shouldDisplayDataCompleteCard
                ? _c(
                    "div",
                    {
                      staticClass:
                        "completeness-page__card completeness-page__card--complete",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "completeness-page__card__icon-wrapper",
                        },
                        [
                          _c("pui-icon", {
                            attrs: {
                              "icon-color": _vm.CHECK_ICON_COLOR,
                              size: _vm.CHECK_ICON_SIZE,
                              "icon-name": "check",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("pui-headline", { attrs: { type: "h4" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "completenessCheckPage.dataCompletePercent",
                                { percentage: "100" }
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _c("calendar-list-view", {
                    attrs: { config: _vm.calendarViewConfiguration },
                    on: { "click:unit": _vm.unitClicked },
                  }),
            ],
            1
          )
        : _c("pui-form-inline-notification", {
            attrs: {
              title: _vm.$t("completenessCheckPage.rangeError.title"),
              text: _vm.$t("completenessCheckPage.rangeError.text", {
                dayCount: _vm.MAX_ONE_MONTH_IN_DAYS,
              }),
              type: "error",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }